import axios from 'axios';
import { url } from 'utils/urls'

const withCredentials = true;
const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };

export const asyncGetMasterAdsTxtFiles = () => axios.get(`${url.spm.url}masteradstxt`, { withCredentials });

export const asyncUpdateMasterFileNote = (version, note, seatType) => axios.put(`${url.spm.url}masteradstxt/${version}`, { note: note, seatType: seatType }, { withCredentials });
